<template>
   <div style="padding-top:70px;" >
    <div id="coursecenter">
        <div class="jingping">
            <div class="jpheader">
                <div class="jpmenu" >
                    <p v-for="item in Labels.fatherLabels">
                        <span>{{item.name}}</span>
                        <span  :class="[item.id== currentId?'av-jpchoose':'','jpchooseall']" :data-labelid="item.id" @click="chooseCourse(item.id,'all')">全部</span>
                       
                        <span  :class="[item1.id == pageData.labelIds?'av-jpchoose':'' ,'jpchoose']" v-for="item1 in Labels.childerLabels" v-if="item1.fatherId == item.id" :data-labelid="item1.id" @click="chooseCourse(item1.id)">{{item1.name}}</span>
                    </p>
                </div>
                <div></div>
                <div></div>
            </div>
            <div class="choose">
                <div>
                    <div :class="[pageData.sorting=='new'?'red':'','choose1']" @click="setsort('new')">最新</div>
                    <div :class="[pageData.sorting=='hot'?'red':'','choose1']"  @click="setsort('hot')">最热</div>
                    <div :class="[pageData.sorting=='maxprice'|| pageData.sorting=='minprice'?'red':'','choose1','choose2']"  @click="setPriceDiv()">
                            <span v-if="pageData.sorting=='maxprice'|| pageData.sorting=='minprice'">{{showPriceTxt}}</span>
                            <span v-else>价格</span>
                            <span><img src="images/jiantou.png"/></span>
                            <div v-show="showPriceDiv" id="lower" style="color: black; display: block;" @click="setsort('maxprice','价格从高到低')">价格从高到低</div>
                            <div v-show="showPriceDiv" id="higher" style="color: black; display: block;"  @click="setsort('minprice','价格从低到高')">价格从低到高</div>
                        </div>
                        <!-- <div class="choose1 freechoose2">免费</div> -->
                </div>
            </div>
            <div class="jpmain">
                <a class="kebox" href="javascript:void(0)" :data-id="item.id" v-for="item in courseList.items" @click="clickKcUrl(item)"> 
                    <p class="courseLabel">{{item.tags}}</p>
                    <img :src="item.thumb" alt="" class="imgbg">    
                    <div class="kctitle" :title="item.title">{{item.title}}</div>    
                    <div class="nums">         
                        <span class="teacher" v-if="item.teacherName">主讲人:{{item.teacherName}}</span>         
                        <span class="stunum">
                            <img src="images/icon-scale.png"> 
                            <span> {{item.studentNum}}</span>
                        </span>              
                        <span class="startTime" v-if="item.startTime!=null">{{item.startTime | dateFormat("YYYY-MM-DD")}}开课</span>            
                    </div> 
                </a>
            </div>
            <div class="pagers">
                <el-pagination
                :current-page.sync="pageData.currentPage"
                :page-size.sync="pageData.pageSize"
                
                :total="pageData.total"
                v-bind="$attrs"
                @current-change="handleCurrentChange"
              />
            </div>
        </div>
    </div>
    <div class="coursefoot"></div>
   </div>
  </template>
  
  <script>
    
    import comFun from "@/common/common";
    //import baseFun from "@/common/common";
    import '@/plugins/element.js'
    export default {
      name: '',
      components: {
        
      },
      filters: {
       dateFormat(dateStr, pattern = '') {
        var dt = new Date(dateStr)
        var yy = dt.getFullYear()
        var mm = (dt.getMonth() + 1).toString().padStart(2, '0')
        var dd = dt.getDate().toString().padStart(2, '0')
        var h = dt.getHours().toString().padStart(2, '0')
        var m = dt.getMinutes().toString().padStart(2, '0')
        var s = dt.getSeconds().toString().padStart(2, '0')
        if (pattern.toLowerCase() === 'yyyy-mm-dd') {
            return yy + '-' + mm + '-' + dd
        } else if(pattern.toLowerCase() === 'yyyy-mm-dd hh:mm'){
            return yy + '-' + mm + '-' + dd + ' ' + h + ':' + m 
        } else if(pattern.toLowerCase() === 'hh:mm'){
            return  h + ':' + m 
        }else {
            return yy + '-' + mm + '-' + dd + ' ' + h + ':' + m + ':' + s
        }
        
    }
    },
    data() {
        return {
            pageData:{
                currentPage:1,
                pageSize:20,
                total:0,
                labelIds:"",
                sorting:""
            },
            Labels:{},
            courseList:{
                items:[]
            },
            currentId: "", // 点击全部的Id
            showPriceDiv:0 ,// 是否显示价格排序
            showPriceTxt:'价格'
        }
    },
    async mounted(){
        this.getCourseList()
        this.Labels = await comFun.getCourseLabels()
    },
    methods:{
        clickKcUrl(item){
            this.$router.push({
                name: 'CourseDetail',
                query: {
                id: item.id
                }
            })
        },
        setPriceDiv(){
            this.showPriceDiv= !this.showPriceDiv
        },
        async getCourseList(){
            var postdata =  {
                labelIds: this.pageData.labelIds,
                maxResultCount: this.pageData.pageSize,
                pageIndex: this.pageData.currentPage - 1,
                sorting: this.pageData.sorting
            }
           comFun.getAllcourse(postdata).then(res=>{
                this.courseList = res
                this.pageData.total = this.courseList.totalCount
            })  
            
        },
        handleCurrentChange() { // 切页
            this.getCourseList()
        },
        chooseCourse(labid,type) {  //点击标签 
            this.currentId = ''
            this.pageData.labelIds  = ''

            if(type ==  "all")  this.currentId = labid
            else this.pageData.labelIds = labid
            this.getCourseList()
        },
        setsort(sort,txt){
            this.pageData.sorting =sort
            if(txt!=null)  this.showPriceTxt = txt
            this.getCourseList()
        }
    }
    
}
  </script>
  
  <style >
    .el-pagination{width: 600px;margin: auto;}
    .pagers .el-pager li {
    padding: 0 4px;
    font-size: 13px;
    min-width: 35.5px;
    height: 28px;
    line-height: 28px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    text-align: center;
    border-radius: 19px;
    width: 40px;
    height: 24px;
    line-height: 24px;
    color: #000;
    border: 1px solid #ddd;
}
.pagers .el-pager li.active{background: #c80f0f;color: #fff;}
.pagers .el-pagination button{height: 24px;line-height: 24px;margin: 0 10px;}
.pagers .el-pagination__editor{line-height: 24px;}
.pagers .el-pagination__editor.el-input .el-input__inner{height:24px;}
.pagers .el-pagination button, .pagers .el-pagination span:not([class*=suffix]){line-height: 24px;height: 24px;}
.pagers .el-pagination button{border:1px solid #ddd}
.pagers .el-pagination__rightwrapper{float: none;    display: inline-block;}
  </style>